import * as React from 'react';

export function randomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function displayTime(time: number) {
  const timeString = time.toString().split('');
  const stringLen = timeString.length;
  const sec = timeString.splice(0, stringLen - 3);
  return [sec.join(''), timeString.join('')];
  // return `${sec.join('')}.${timeString.join('')}ms`;
}

export function displayDate(date: string) {
  const dt = date.split('T');
  return <div className="display-date">{dt[0]}<br />{dt[1].slice(0, 8)}</div>;
}

